<div class="page">
  <div class='page-wrapper'>
    <div class="body-wrapper">


      <div *ngFor="let product of products">
        <a href="#" [routerLink]="'/store-item/' + product.id">
          <img [src]="product.image">
        </a>
      </div>


    </div>
  </div>
</div>